module.exports = __webpack_public_path__ + "static/media/RazPoses_0006_quiz_time.c2999b23.png";